import { computed } from "vue"
import { portalURL } from "@/common/constants/portalLinks"
import i18n from "@/i18n"
import getEnv from "@/common/util/env"

export const useLinks = () => {
  const localeParamForLinks = computed<string>(() => {
    return i18n.global.locale.value === "en" || i18n.global.locale.value === "de"
      ? i18n.global.locale.value
      : "en"
  })

  const termsandcondition = computed<string>(() => {
    let termsLink =
      "cms/assets/33b9a515-391d-411d-8c28-98e2f9d674eb/General%20T%26Cs%20for%20IT%20Services.pdf"
    if (i18n.global.locale.value === "de") {
      termsLink =
        "cms/assets/9cf6db64-949b-4891-9b13-4c0c06d7a812/Allgemeine%20Gesch%C3%A4ftsbedingungen%20IT-Leistungen.pdf"
    }
    return `${portalURL}/${termsLink}`
  })

  const dataPrivacyStatement = computed<string>(() => {
    let defaultLink = "privacy-policy"
    if (localeParamForLinks.value === "de") {
      defaultLink = "datenschutz"
    }

    return `${portalURL}/${localeParamForLinks.value}/${defaultLink}`
  })

  const getLinkToPDF = (fileName: string): string => {
    return `${fileName}-${localeParamForLinks.value}.pdf`
  }

  const consumer = () => {
    return {
      howDoesItWork: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect-catena-x/search-data-offers-catena-x-manual`
    }
  }

  const provider = () => {
    return {
      subModelHelpLink: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect-catena-x/types-of-submodels-in-catena-x`,
      policyHelpLink: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect-catena-x/policy-overview-in-catena-x`,
      howDoesItWork: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect-catena-x/search-data-offers-catena-x-manual`
    }
  }

  const helpSection = () => {
    return {
      documentation: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/get-to-know-your-connect-integrate`,
      licences: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect/software-and-licensing-information`
    }
  }

  const footerLinks = () => {
    return {
      tutorials: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect-catena-x/connect-integrate-catena-x-tutorials-demos`,
      glossary: `${getEnv("VITE_APP_DIH_URL")}/en/glossary`
    }
  }

  const sampleFiles = () => {
    return {
      sampleFilesCsv: `${getEnv("VITE_APP_DIH_DOC_URL")}/en/connect-catena-x/connect-integrate-catena-x/csv-templates-and-samples`
    }
  }

  return {
    termsandcondition,
    dataPrivacyStatement,
    getLinkToPDF,
    consumer,
    provider,
    helpSection,
    footerLinks,
    sampleFiles
  }
}
